<div class="wrapper">
    <ion-img src="../../../../assets/img/place.svg"></ion-img>
    <p class="title">Bestelling afleveren?</p>
    <p class="content">Heb je deze bestelling bij de klant afgeleverd?</p>
    <ion-button class="go" (click)="deliveredToClient()">
        <ion-spinner name="crescent" *ngIf="isConfirmingDelivery"></ion-spinner>
        <span class="content" *ngIf="!isConfirmingDelivery">
            <ion-icon slot="start" src="../../../../assets/icon/avatar.svg"></ion-icon>
            <div>Aan de klant</div>
        </span>
    </ion-button>
    <ion-button class="secondary" color="secondary" class="go" (click)="deliveredAtDoor()">
        <ion-spinner name="crescent" color="primary" *ngIf="isConfirmingDelivery"></ion-spinner>
        <span class="content" *ngIf="!isConfirmingDelivery">
            <ion-icon slot="start" src="../../../../assets/icon/door.svg"></ion-icon>
            <div>Voor de deur</div>
        </span>
    </ion-button>
    <ion-button class="cancel" fill="clear" (click)="close()">Annuleer</ion-button>
</div>